import { useContext } from "react";
import { PageLayoutContext } from "./PageLayoutContext.js";

export const usePageLayoutContext = () => useContext(PageLayoutContext);
